/**
 * Dashboard Service
 *
 * API calls for dashboard data
 */

import { api } from '../lib/api';

export interface DashboardStats {
  products: {
    total: number;
    active: number;
    draft: number;
  };
  users: {
    total: number;
    newToday: number;
  };
  inquiries: {
    total: number;
    pending: number;
    inProgress: number;
    completed: number;
    newToday: number;
  };
  contacts: {
    total: number;
    new: number;
    todayCount: number;
  };
}

export interface RecentActivity {
  id: string;
  type: 'user_registered' | 'inquiry_created' | 'contact_submitted' | 'quote_sent';
  description: string;
  createdAt: string;
}

export const dashboardService = {
  getStats: async (): Promise<DashboardStats> => {
    const response = await api.get<DashboardStats>('/admin/dashboard/stats');
    return response.data!;
  },

  getRecentActivities: async (limit: number = 10): Promise<RecentActivity[]> => {
    const response = await api.get<RecentActivity[]>(`/admin/dashboard/activities?limit=${limit}`);
    return response.data || [];
  },
};
